import { render, staticRenderFns } from "./photo-table-column.vue?vue&type=template&id=4cc2cf81&"
import script from "./photo-table-column.vue?vue&type=script&lang=js&"
export * from "./photo-table-column.vue?vue&type=script&lang=js&"
import style0 from "./photo-table-column.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports